<template>
  <div class="static-block-placement" v-if="content && content.length">
    <div class="static-block"
         v-for="(text, index) in content"
         v-html="text"
         :key="index"/>
  </div>
</template>


<script>
import {mapGetters, mapState} from 'vuex';
import {SLIDES_TYPES, URL_QUERIES} from '@/const';
import {
  CATEGORY_BY_ALIAS_MAP,
  GROUPS_BY_ALIAS_MAP,
  PARTICIPANTS_BY_ALIAS_MAP,
} from '@/store/getterTypes';

export default {
  name: 'StaticBlockComponent',
  data() {
    return {
      [SLIDES_TYPES.category]: this.$route.query?.[URL_QUERIES.category]?.toLowerCase(),
      [SLIDES_TYPES.group]: this.$route.query?.[URL_QUERIES.participantGroup]?.toLowerCase(),
      [SLIDES_TYPES.participant]: this.$route.query?.[URL_QUERIES.PARTICIPANT]?.toLowerCase(),
    };
  },
  props: {
    page: null,
    position: null,
  },
  watch: {
    $route() {
      this[SLIDES_TYPES.category] = this.$route.query?.[URL_QUERIES.category]?.toLowerCase();
      this[SLIDES_TYPES.group] = this.$route.query?.[URL_QUERIES.participantGroup]?.toLowerCase();
      this[SLIDES_TYPES.participant] = this.$route.query?.[URL_QUERIES.PARTICIPANT]?.toLowerCase();
    },
  },
  computed: {
    ...mapState({
      staticBlocks: (state) => state.channel.staticBlocks,
    }),
    ...mapGetters({
      categoryMap: CATEGORY_BY_ALIAS_MAP,
      participantsMap: PARTICIPANTS_BY_ALIAS_MAP,
      groupMap: GROUPS_BY_ALIAS_MAP,
    }),
    maps() {
      return {
        [SLIDES_TYPES.category]: this.categoryMap,
        [SLIDES_TYPES.participant]: this.participantsMap,
        [SLIDES_TYPES.group]: this.groupMap,
      };
    },
    content() {
      const blocksList = this.staticBlocks?.[this.page]?.[this.position];
      if (!blocksList) return;

      const position = (Array.isArray(blocksList) ? blocksList : [blocksList])?.filter((block) => {
        const alias = this[block.blockable_type];
        return Number(this.maps[block.blockable_type][alias]?.id) === Number(block.blockable_id);
      });

      return position.map(({content}) => this.convertEditorJsonToHtml(content));
    },
  },
};
</script>

<style lang="scss">
.static-block {
  max-width: 100vw;

  img {
    width: 100%;
  }
}
</style>
